import { render } from "./ProductosMedicos.vue?vue&type=template&id=13b9bd46&scoped=true"
import script from "./ProductosMedicos.vue?vue&type=script&lang=js"
export * from "./ProductosMedicos.vue?vue&type=script&lang=js"

import "./ProductosMedicos.vue?vue&type=style&index=0&id=13b9bd46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b9bd46"]])

export default __exports__